import styled from "styled-components";

export const TrailerTypeItemStyles = styled.div`
  display: flex;
  align-items: center;

  .ID {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: #171725;
  }

  .userText {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: #171725;
  }

  .actionButtons {
    border-radius: 6px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    padding: 8px 16px;
  }
`;
